import { types as t } from 'mobx-state-tree';
import { AbstractQuestionWithBlanks } from '../abstract-question-with-blanks.store';
import { AbstractQuestionWithBlankCorrectAnswers } from '../abstract-question-with-blank-correct-answers.store';

const Paragraph = AbstractQuestionWithBlanks.named('Paragraph');

export const NoteCompletionAnswerQuestion = AbstractQuestionWithBlankCorrectAnswers.named(
  'NoteCompletionQuestion'
).props({
  heading: t.maybeNull<any>(t.string),
  paragraph: t.maybeNull(Paragraph),
});
